import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import './StatsSection.css';

const stats = [
  { value: 200, label: 'COLLEGES TRAINED', suffix: '+' },
  { value: 50000, label: 'CVS OPTIMISED', suffix: 'k+', display: '50k+' },
  { value: 3, label: 'SECURED JOB', suffix: 'x' }
];

// Animated Counter Component (now takes 'active' prop)
function AnimatedCount({ value, suffix, display, duration = 1200, active }) {
  const ref = useRef();
  useEffect(() => {
    if (!active) return;
    const end = value;
    const timer = duration / (end || 1) > 18 ? Math.round(duration / end) : 18;
    let curr = 0, inc = Math.ceil(end / (duration / timer));
    const update = () => {
      curr += inc;
      if (curr > end) curr = end;
      if (ref.current) {
        if (display) ref.current.textContent = display;
        else ref.current.textContent = curr + (suffix || '');
      }
      if (curr < end) setTimeout(update, timer);
    };
    update();
  }, [value, suffix, display, duration, active]);
  return <span ref={ref} className="stats-value"/>;
}

const StatsSection = ({ theme = 'dark' }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section ref={ref} className={`stats-section theme-${theme} ${inView ? 'visible' : ''}`}>
      <div className="stats-row-main">
        {/* LEFT SIDE */}
        <div className="stats-main-left">
          <h1 className="main-headline">
            LAND IN YOUR
            <span className="main-highlight">DREAM JOB</span>
          </h1>
          <div className="main-subtext">
            Transform your career with expert resume optimization,<br/>
            interview guidance, and real-world job training.
          </div>
        </div>
        {/* RIGHT SIDE with Circles & Star */}
        <div className="stats-main-right">
          <svg className="circles-bg" viewBox="0 0 320 320" fill="none">
            <circle cx="160" cy="160" r="115" stroke="var(--circle-line)" strokeWidth="1.4" />
            <circle cx="160" cy="160" r="75" stroke="var(--circle-line)" strokeWidth="1.4" />
            <circle cx="160" cy="160" r="40" stroke="var(--circle-line)" strokeWidth="1.4" />
            <polygon points="180,120 184,135 200,135 187,144 192,160 180,150 168,160 173,144 160,135 176,135"
              fill="var(--star-fill)" />
          </svg>
        </div>
      </div>
      {/* STATS */}
      <div className="stats-numbers">
        {stats.map((item, index) => (
          <div className="stats-block" style={{ "--stats-index": index }} key={index}>
            <div className="stats-block-value">
              <AnimatedCount value={item.value} suffix={item.suffix} display={item.display} active={inView} />
            </div>
            <div className="stats-block-label">{item.label}</div>
            {index < stats.length - 1 && <span className="stats-block-sep" />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
